import { type FormEvent, type RefObject } from 'react'

import {
  TextareaSuggestable,
  type TextareaSuggestableActions,
} from '../../TextareaSuggestable'
import { Button } from '../../../../../../../components/Button'
import { type TaskCommentDomain } from '../../../../../../../types/domain/task-comment-domain'

type CommentFormProps = {
  isSubmitButtonDisabled: boolean
  selectedComment?: TaskCommentDomain | null
  textareaSuggestableMethodsRef: RefObject<TextareaSuggestableActions>
  isSubmitting: boolean
  onCancel: () => void
  onSubmit: (event: FormEvent<HTMLFormElement>) => void
}

export const CommentForm = ({
  isSubmitButtonDisabled,
  selectedComment,
  textareaSuggestableMethodsRef,
  isSubmitting,
  onSubmit,
  onCancel,
}: CommentFormProps) => {
  return (
    <form onSubmit={onSubmit}>
      <TextareaSuggestable
        ref={textareaSuggestableMethodsRef}
        contentRaw={
          selectedComment?.contentRaw && JSON.parse(selectedComment.contentRaw)
        }
      />

      <div className="flex justify-end mt-6 space-x-2">
        {selectedComment && (
          <Button type="button" variant="outline" onClick={onCancel}>
            Cancelar
          </Button>
        )}

        <Button
          type="submit"
          isLoading={isSubmitting}
          disabled={isSubmitButtonDisabled}
        >
          {selectedComment ? 'Salvar' : 'Comentar'}
        </Button>
      </div>
    </form>
  )
}
